<div class="widget">
  <div class="amSuite-widget-header">
    {{ 'widgets.last-used.title' | translate }}
  </div>

  <div class="amSuite-widget-block height-auto">
    @if (hasLastTemplates()) {
    <div class="cw-list">
      @for (t of lastTemplates; track $index) {
      <article class="cw-row">
        <span class="cw-ico" aria-hidden="true">
          <span class="cw-tile"><i class="pi pi-file-edit"></i></span>
        </span>
        <div class="cw-main">
          <span class="cw-rtitle" [title]="t.name">{{ t.name }}</span>
          @if (t.package) {
          <div class="cw-tag">{{ t.package }}</div>
          }
          @if (t.description) {
          <div class="cw-sub"><span>{{ t.description }}</span></div>
          }
        </div>
      </article>
      }
    </div>
    }
    @else {
    <div class="noResultsLabel">{{ 'widgets.last-used.no-data' | translate }}</div>
    }
  </div>
</div>
